/* YAZ Origin — handover chooser (pick-up | delivered to me) with address search + draggable pin.
   Google Maps JS (Places + Geocoder) when a browser key is set in Theme settings → YAZ; otherwise Leaflet + OpenStreetMap
   (CARTO dark tiles, Nominatim search) so the flow works without any key. Emits `ya:handover` on the widget root with
   {mode, address, lat, lng} — consumed by ya-motion.js (hero form + PDP WhatsApp text / line-item properties). */
(function () {
  'use strict';
  var d = document, w = window;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var params = new URLSearchParams(w.location.search);
  var DUBAI = { lat: 25.2048, lng: 55.2708 }, OFFICE = { lat: 25.1741, lng: 55.3144 }; // Azizi Riviera 3, Al Merkadh (Meydan)
  var UAE_BOUNDS = { south: 22.6, west: 51.5, north: 26.1, east: 56.4 };

  function loadScript(src, onload, onerror) { var s = d.createElement('script'); s.src = src; s.async = true; s.defer = true; s.onload = onload; s.onerror = onerror; d.head.appendChild(s); }
  function loadCss(href) { if ($('link[href="' + href + '"]')) return; var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = href; d.head.appendChild(l); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function shortAddr(s) { if (!s) return ''; var parts = s.split(',').map(function (p) { return p.trim(); }).filter(Boolean); var out = [], seen = {}; parts.forEach(function (p) { if (/united arab emirates|^uae$|^\d{5,}$/i.test(p)) return; if (seen[p.toLowerCase()]) return; seen[p.toLowerCase()] = 1; out.push(p); }); return out.slice(0, 4).join(', '); }

  var gmapsLoading = null;
  function ensureGoogle(key, lang) {
    if (w.google && w.google.maps && w.google.maps.places) return Promise.resolve(true);
    if (gmapsLoading) return gmapsLoading;
    gmapsLoading = new Promise(function (res) {
      w.__yaGmapsReady = function () { res(true); };
      var src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&v=weekly&loading=async&region=AE&language=' + (lang || 'en') + '&callback=__yaGmapsReady';
      loadScript(src, null, function () { res(false); });
      setTimeout(function () { res(!!(w.google && w.google.maps)); }, 12000);
    });
    return gmapsLoading;
  }
  var leafletLoading = null;
  function ensureLeaflet(jsUrl, cssUrl) {
    if (w.L && w.L.map) return Promise.resolve(true);
    if (leafletLoading) return leafletLoading;
    loadCss(cssUrl);
    leafletLoading = new Promise(function (res) { loadScript(jsUrl, function () { res(!!w.L); }, function () { res(false); }); });
    return leafletLoading;
  }

  var DARK_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#1b1b1b' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#a8a8a8' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#121212' }] },
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#202520' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2c2c2c' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#1f1f1f' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3a3a3a' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0b0f14' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#4e6d7c' }] }
  ];

  function Handover(root) {
    var self = this;
    this.root = root;
    this.ctx = root.getAttribute('data-ctx') || 'hero';
    this.key = (root.getAttribute('data-gmaps-key') || '').trim();
    this.lang = root.getAttribute('data-lang') || 'en';
    this.t = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    this.radios = $$('[data-ya-mode]', root);
    this.opts = $$('[data-ya-opt]', root);
    this.panel = $('[data-ya-delivery-panel]', root);
    this.pickupHint = $('[data-ya-pickup-hint]', root);
    this.input = $('[data-ya-address]', root);
    this.results = $('[data-ya-results]', root);
    this.mapEl = $('[data-ya-map]', root);
    this.lat = $('[data-ya-lat]', root); this.lng = $('[data-ya-lng]', root);
    this.err = $('[data-ya-err]', root);
    this.locate = $('[data-ya-locate]', root);
    this.state = { mode: 'pickup', address: '', lat: '', lng: '' };
    this.mapReady = false; this.provider = null;
    root.__ya = this; // expose before the first emit so listeners (ya-motion.js) can read state

    this.radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) self.setMode(r.value, true); }); });
    this.opts.forEach(function (o) { o.addEventListener('click', function () { var r = $('input', o); if (r && !r.checked) { r.checked = true; self.setMode(r.value, true); } }); });
    if (this.input) {
      this.input.addEventListener('input', debounce(function () { self.onType(); }, 380));
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var first = $('[data-ya-hit]', self.results); if (first) first.click(); else self.onType(true); } if (e.key === 'Escape') self.hideResults(); });
      d.addEventListener('click', function (e) { if (!root.contains(e.target)) self.hideResults(); });
    }
    if (this.locate) this.locate.addEventListener('click', function () { self.useMyLocation(); });

    // prefill from URL (hero → PDP handoff)
    var pm = params.get('mode');
    if (pm === 'delivery') {
      var r = this.radios.filter(function (x) { return x.value === 'delivery'; })[0]; if (r) r.checked = true;
      this.state.address = params.get('address') || ''; this.state.lat = params.get('lat') || ''; this.state.lng = params.get('lng') || '';
      if (this.input) this.input.value = this.state.address;
      if (this.lat) this.lat.value = this.state.lat; if (this.lng) this.lng.value = this.state.lng;
      this.setMode('delivery', false);
    } else { this.setMode('pickup', false); }
  }
  Handover.prototype.emit = function () {
    var ev; try { ev = new CustomEvent('ya:handover', { bubbles: true, detail: this.state }); } catch (e) { ev = d.createEvent('CustomEvent'); ev.initCustomEvent('ya:handover', true, false, this.state); }
    this.root.dispatchEvent(ev);
  };
  Handover.prototype.setMode = function (mode, user) {
    var self = this; this.state.mode = mode;
    this.opts.forEach(function (o) { var on = o.getAttribute('data-ya-opt') === mode; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
    if (this.panel) this.panel.hidden = mode !== 'delivery';
    if (this.pickupHint) this.pickupHint.hidden = mode === 'delivery';
    this.root.classList.toggle('is-delivery', mode === 'delivery');
    this.showError('');
    if (mode === 'delivery') {
      this.initMap().then(function () { if (user && self.input && !self.state.address) { try { self.input.focus(); } catch (e) {} } });
    }
    this.emit();
  };
  Handover.prototype.showError = function (msg) { if (!this.err) return; this.err.textContent = msg || ''; this.err.hidden = !msg; };
  Handover.prototype.validate = function () {
    if (this.state.mode !== 'delivery') return true;
    if (this.input && this.input.value.trim() && !this.state.address) this.state.address = this.input.value.trim();
    if (!this.state.address) { this.showError(this.t('required')); if (this.input) this.input.focus(); return false; }
    return true;
  };
  Handover.prototype.setPoint = function (lat, lng, address, opts) {
    opts = opts || {};
    this.state.lat = lat != null ? (+lat).toFixed(6) : ''; this.state.lng = lng != null ? (+lng).toFixed(6) : '';
    if (address != null) { this.state.address = address; if (this.input) this.input.value = address; }
    if (this.lat) this.lat.value = this.state.lat; if (this.lng) this.lng.value = this.state.lng;
    if (this.provider && lat != null && !opts.fromMap) this.provider.moveTo(+lat, +lng, opts.zoom);
    this.showError(''); this.hideResults(); this.emit();
  };
  Handover.prototype.hideResults = function () { if (this.results) { this.results.hidden = true; this.results.innerHTML = ''; } };
  Handover.prototype.renderResults = function (items) {
    var self = this; if (!this.results) return;
    this.results.innerHTML = '';
    if (!items.length) { var li = d.createElement('li'); li.className = 'ya-handover__nores'; li.textContent = this.t('no-results'); this.results.appendChild(li); this.results.hidden = false; return; }
    items.forEach(function (it) {
      var li = d.createElement('li'); var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-ya-hit', ''); b.setAttribute('role', 'option');
      var main = d.createElement('strong'); main.textContent = it.main; var sub = d.createElement('small'); sub.textContent = it.sub || '';
      b.appendChild(main); if (it.sub) b.appendChild(sub);
      b.addEventListener('click', function () { it.pick(); });
      li.appendChild(b); self.results.appendChild(li);
    });
    this.results.hidden = false;
  };
  Handover.prototype.onType = function (force) {
    var q = this.input ? this.input.value.trim() : '';
    this.state.address = q; if (this.lat) { this.lat.value = ''; this.lng.value = ''; } this.state.lat = ''; this.state.lng = '';
    this.emit();
    if (q.length < 3) { this.hideResults(); return; }
    if (this.provider && this.provider.search) this.provider.search(q, force);
  };
  Handover.prototype.useMyLocation = function () {
    var self = this; if (!navigator.geolocation) return;
    this.locate.classList.add('is-busy');
    navigator.geolocation.getCurrentPosition(function (p) {
      self.locate.classList.remove('is-busy');
      var lat = p.coords.latitude, lng = p.coords.longitude;
      self.setPoint(lat, lng, self.t('my-location'), { zoom: 16 });
      if (self.provider && self.provider.reverse) self.provider.reverse(lat, lng);
    }, function () { self.locate.classList.remove('is-busy'); });
  };
  Handover.prototype.initMap = function () {
    var self = this;
    if (this.mapReady) return Promise.resolve(true);
    if (this.mapInit) return this.mapInit;
    var start = this.state.lat ? { lat: +this.state.lat, lng: +this.state.lng } : null;
    var p = this.key ? ensureGoogle(this.key, this.lang).then(function (ok) { return ok ? self.googleProvider(start) : self.leafletProvider(start); }) : this.leafletProvider(start);
    this.mapInit = p.then(function (ok) { self.mapReady = !!ok; if (!ok) { self.mapEl.classList.add('is-missing'); self.mapEl.textContent = self.t('map-missing'); } return ok; });
    return this.mapInit;
  };

  /* ---- Google provider ---- */
  Handover.prototype.googleProvider = function (start) {
    var self = this, g = w.google.maps;
    var center = start || DUBAI;
    var map = new g.Map(this.mapEl, { center: center, zoom: start ? 15 : 11, styles: DARK_STYLE, disableDefaultUI: true, zoomControl: true, gestureHandling: 'greedy', clickableIcons: false, backgroundColor: '#141414' });
    var marker = new g.Marker({ map: map, position: start || undefined, draggable: true, title: this.t('pin') });
    var geocoder = new g.Geocoder();
    var reverse = function (lat, lng) { geocoder.geocode({ location: { lat: lat, lng: lng } }, function (res, status) { if (status === 'OK' && res && res[0]) { self.setPoint(lat, lng, shortAddr(res[0].formatted_address), { fromMap: true }); } else { self.setPoint(lat, lng, (+lat).toFixed(5) + ', ' + (+lng).toFixed(5), { fromMap: true }); } }); };
    marker.addListener('dragend', function () { var p = marker.getPosition(); reverse(p.lat(), p.lng()); });
    map.addListener('click', function (e) { marker.setPosition(e.latLng); reverse(e.latLng.lat(), e.latLng.lng()); });
    var ac = null;
    try {
      ac = new g.places.Autocomplete(this.input, { componentRestrictions: { country: 'ae' }, fields: ['geometry', 'formatted_address', 'name'], bounds: new g.LatLngBounds({ lat: UAE_BOUNDS.south, lng: UAE_BOUNDS.west }, { lat: UAE_BOUNDS.north, lng: UAE_BOUNDS.east }), strictBounds: false });
      ac.addListener('place_changed', function () {
        var pl = ac.getPlace(); if (!pl || !pl.geometry) return;
        var loc = pl.geometry.location, addr = (pl.name && pl.formatted_address && pl.formatted_address.indexOf(pl.name) < 0 ? pl.name + ', ' : '') + (pl.formatted_address || pl.name);
        marker.setPosition(loc); map.panTo(loc); map.setZoom(16);
        self.setPoint(loc.lat(), loc.lng(), shortAddr(addr), { fromMap: true });
      });
    } catch (e) { ac = null; }
    this.provider = {
      moveTo: function (lat, lng, zoom) { var ll = { lat: lat, lng: lng }; marker.setPosition(ll); map.panTo(ll); if (zoom) map.setZoom(zoom); },
      reverse: reverse,
      search: ac ? null : function (q) { geocoder.geocode({ address: q, region: 'ae', componentRestrictions: { country: 'AE' } }, function (res, status) { if (status !== 'OK' || !res) { self.renderResults([]); return; } self.renderResults(res.slice(0, 6).map(function (r) { var loc = r.geometry.location; return { main: shortAddr(r.formatted_address), sub: '', pick: function () { self.setPoint(loc.lat(), loc.lng(), shortAddr(r.formatted_address), { zoom: 16 }); } }; })); }); }
    };
    return Promise.resolve(true);
  };

  /* ---- Leaflet / OSM provider (no key needed) ---- */
  Handover.prototype.leafletProvider = function (start) {
    var self = this, js = this.root.getAttribute('data-leaflet-js') || (w.__yaAssets && w.__yaAssets.leafletJs), css = this.root.getAttribute('data-leaflet-css') || (w.__yaAssets && w.__yaAssets.leafletCss);
    if (!js) return Promise.resolve(false);
    return ensureLeaflet(js, css).then(function (ok) {
      if (!ok) return false;
      var L = w.L, center = start || DUBAI;
      var map = L.map(self.mapEl, { center: [center.lat, center.lng], zoom: start ? 15 : 11, zoomControl: true, attributionControl: true, scrollWheelZoom: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, className: 'ya-tiles-dark', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);
      var icon = L.divIcon({ className: 'ya-pin', html: '<span class="ya-pin__dot"></span>', iconSize: [28, 36], iconAnchor: [14, 34] });
      var marker = L.marker([center.lat, center.lng], { draggable: true, icon: icon, title: self.t('pin'), opacity: start ? 1 : 0 }).addTo(map);
      var show = function () { marker.setOpacity(1); };
      var headers = { 'Accept': 'application/json', 'Accept-Language': self.lang === 'ar' ? 'ar,en' : 'en' };
      var reverse = function (lat, lng) {
        fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&lat=' + lat + '&lon=' + lng, { headers: headers }).then(function (r) { return r.json(); }).then(function (j) {
          var a = j && j.address ? j.address : {}, name = j && j.name ? j.name : '';
          var parts = [name, a.building, a.hotel, a.road, a.neighbourhood || a.suburb || a.quarter, a.city || a.town || a.state];
          var out = [], seen = {}; parts.forEach(function (p) { if (p && !seen[p]) { seen[p] = 1; out.push(p); } });
          self.setPoint(lat, lng, out.slice(0, 4).join(', ') || (j && j.display_name ? shortAddr(j.display_name) : (+lat).toFixed(5) + ', ' + (+lng).toFixed(5)), { fromMap: true });
        }).catch(function () { self.setPoint(lat, lng, (+lat).toFixed(5) + ', ' + (+lng).toFixed(5), { fromMap: true }); });
      };
      marker.on('dragend', function () { var p = marker.getLatLng(); reverse(p.lat, p.lng); });
      map.on('click', function (e) { marker.setLatLng(e.latlng); show(); reverse(e.latlng.lat, e.latlng.lng); });
      var lastQ = '';
      self.provider = {
        moveTo: function (lat, lng, zoom) { marker.setLatLng([lat, lng]); show(); map.setView([lat, lng], zoom || Math.max(map.getZoom(), 15)); },
        reverse: reverse,
        search: function (q) {
          if (q === lastQ) return; lastQ = q;
          self.results.innerHTML = ''; var li = d.createElement('li'); li.className = 'ya-handover__nores'; li.textContent = self.t('searching'); self.results.appendChild(li); self.results.hidden = false;
          // Photon (komoot) = OSM autocomplete geocoder; biased to Dubai, boxed to the UAE. Nominatim is the fallback.
          var photon = 'https://photon.komoot.io/api/?limit=8&lang=' + (self.lang === 'ar' ? 'ar' : 'en') + '&lat=' + DUBAI.lat + '&lon=' + DUBAI.lng + '&bbox=' + UAE_BOUNDS.west + ',' + UAE_BOUNDS.south + ',' + UAE_BOUNDS.east + ',' + UAE_BOUNDS.north + '&q=' + encodeURIComponent(q);
          var rank = { hotel: 0, apartments: 1, attraction: 1, mall: 1, tower: 1, residential: 2, retail: 2, commercial: 2, office: 2, yes: 2, aerodrome: 0, terminal: 0, beach: 2, marina: 2, suburb: 3, neighbourhood: 3, quarter: 3, city: 4, bus_stop: 9, bus_station: 9, platform: 9, tram_stop: 9, parking: 8, parking_space: 9, construction: 7, restaurant: 6, cafe: 6, fast_food: 7, community_centre: 7 };
          var render = function (items) { if (q === lastQ) self.renderResults(items); };
          fetch(photon, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
            var fs = (j && j.features) || [];
            fs = fs.map(function (f, i) { var p = f.properties || {}; var r = rank[p.osm_value]; if (r == null) r = 5; return { f: f, p: p, r: r, i: i }; })
              .sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); }).slice(0, 6);
            if (!fs.length) throw new Error('empty');
            render(fs.map(function (o) {
              var p = o.p, c = o.f.geometry.coordinates, main = p.name || p.street || p.district || p.city || q;
              var sub = [p.street && p.street !== main ? p.street : null, p.district || p.locality, p.city || p.county || p.state].filter(Boolean).filter(function (x, k, arr) { return x !== main && arr.indexOf(x) === k; }).slice(0, 3).join(', ');
              return { main: main, sub: sub, pick: function () { self.setPoint(+c[1], +c[0], sub ? main + ', ' + sub : main, { zoom: 16 }); } };
            }));
          }).catch(function () {
            var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&limit=6&countrycodes=ae&viewbox=' + UAE_BOUNDS.west + ',' + UAE_BOUNDS.north + ',' + UAE_BOUNDS.east + ',' + UAE_BOUNDS.south + '&q=' + encodeURIComponent(q);
            fetch(url, { headers: headers }).then(function (r) { return r.json(); }).then(function (arr) {
              var skip = { bus_stop: 1, bus_station: 1, platform: 1, parking_space: 1, tram_stop: 1 };
              arr = (arr || []).slice().sort(function (a, b) { return (b.importance || 0) - (a.importance || 0); });
              var good = arr.filter(function (h) { return !skip[h.type]; }); if (good.length) arr = good;
              render(arr.map(function (h) {
                var a = h.address || {}, main = h.name || (h.display_name || '').split(',')[0], sub = [a.road, a.neighbourhood || a.suburb, a.city || a.town || a.state].filter(Boolean).filter(function (x) { return x !== main; }).slice(0, 3).join(', ');
                return { main: main, sub: sub, pick: function () { self.setPoint(+h.lat, +h.lon, sub ? main + ', ' + sub : main, { zoom: 16 }); } };
              }));
            }).catch(function () { render([]); });
          });
        }
      };
      setTimeout(function () { map.invalidateSize(); }, 250);
      return true;
    });
  };

  function boot() { $$('[data-ya-handover]').forEach(function (r) { if (!r.__ya) new Handover(r); }); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  w.__yaHandoverBoot = boot;
})();
